module.exports = __webpack_public_path__ + "img/gb9115_30_c.prt.61d9797d.jpg";